import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from '@/app.module';
import * as Sentry from '@sentry/angular';
import { environment } from './environments/environment';
import { APP_RELEASE } from './environments/version';

Sentry.init({
  dsn: 'https://544b57686b144a959c9cd6d203376b6f@o4504548216733696.ingest.sentry.io/4504548784472064',
  environment: environment.tag,
  // Without release/dist every event reported `release: null`, which broke Release Health.
  // APP_RELEASE is written at build time from $BITBUCKET_COMMIT and the `sentry-release`
  // step in .github/workflows/ci.yml creates the same name from the same variable.
  release: `wr-dashboard@${APP_RELEASE}`,
  dist: APP_RELEASE,
  integrations: [
    // v9: functional integration. Router instrumentation is wired via the
    // Sentry.TraceService provider in AppModule.
    Sentry.browserTracingIntegration(),
  ],
  tracePropagationTargets: ['localhost', environment.apiUrl],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});

if (environment.tag === 'production' || environment.tag === 'staging') {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then(success => console.log('Bootstrap success'))
  .catch(err => console.error(err));
